<template>
  <div class="second-step-component">
    <address-window v-if="secondStepWindow === 'address'" />
    <payment-window v-if="secondStepWindow === 'payment'" />
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import AddressWindow from './address-window/AddressWindow'
  import PaymentWindow from './payment-window/PaymentWindow'

  export default {
    name: 'SecondStep',
    components: {
      AddressWindow,
      PaymentWindow,
    },
    computed: {
      ...mapState({
        basket: (state) => state.baskets.basket,
        secondStepWindow: (state) => state.fastOrder.secondStepWindow,
      }),
    },
  }
</script>

<style lang="less" scoped>
.second-step-component {
}
</style>
